
import { Component, Vue, Prop } from 'vue-property-decorator'
import axios from 'axios'
import Constants from '@/constants';
import { TestPaperIVO, TestPaperLibraryOVO, TestPaperOVO } from '@/views/biz/omr/vo/Omr.vo';
import CommonUtils from '@/common-utils';

@Component
export default class TestPaperDialog extends Vue {
  @Prop() emNo!: string;
  @Prop() testPaperCount!: number;
  model = false;
  isDelete = false;
  imgWidth = 800;
  isDrag = false;
  windowSize = {
    x: 0,
    y: 0,
  }

  // 기출문제 시험지 라이브러리에서 조회한 결과
  testPaperLibraries: Array<TestPaperLibraryOVO> = [] as Array<TestPaperLibraryOVO>;
  testPapers: Array<TestPaperOVO> = [] as Array<TestPaperOVO>
  currentSelectedTestPaperImg = '';
  isLoadedTestImages = false;

  // 카드 사이즈
  get windowResizer1() {
    let margingBottom = 260;
    if(this.getWindowSize() < 400) {
      margingBottom = 150;
    }
    return `${this.windowSize.y - 64 - 24 - 24 - margingBottom}px`;
  } 

  // 기출문제 시험 이미지 삭제 버튼
  toggleTestPaperDelete() {
    // 확대된 사진 축소
    this.model = false;
    this.isDelete = ! this.isDelete;
  }

  escKeyDownEventHandler(e) {
    if(e.keyCode != 27) {
      return;
    }
    this.closeDialog();
  }

  closeDialog() {
    this.$store.dispatch(`testPaper/closeModal`, {name: 'testPaper'});
  }

  outsideClickEventHandler() {
    this.closeDialog();
  }

  // 드래그일 경우에 실행됨(클릭과 구분하기 위한 꼼수)
  toggleDrag() {
    this.isDrag = true;
  }

  // 시험지 썸네일 슬라이드
  toggleTestPaperThumbnail(item: string): void {
    this.model = !this.model;
    this.currentSelectedTestPaperImg = item;
  }

  // 이미지 선택
  selectPhoto(): void {
    this.isDelete = false;
    (this.$refs.testPaperFile as HTMLElement).click()
  }

  // 파일 선택
  selectFiles(e): void {
    this.model = false;
    const formData = new FormData();
    for(const file of e.target.files) {
      if(!file.type.match(e.target.accept)) {
        alert('이미지 파일만 가능해요');
        return;
      }

      formData.append("files", file);
    }
    formData.append("fileType", "testPaper");

    axios.post('/common/upload-files', formData, {headers: {'Content-Type': 'multipart/form-data'}})
    .then(r => {
      const result = r.data;

      for(const file of result) {
        const uploadFile = file.file;

        const param = {} as TestPaperIVO;
        param.tpImgNm = uploadFile.fmCvtFileNm;
        param.tpImgNo = uploadFile.fmNo;
        param.emNo = this.emNo;

        axios.post('omr/test-paper', param)
        .then(r => {
          axios.get(`omr/test-papers`, {params: {emNo: this.emNo}})
          .then(r => {
            this.testPapers = r.data
            this.$emit('update:testPaperCount', this.testPapers.length)
          })
        })
      }
    })
  }

  // dragscroll 때문에 부득이하게 추가됨
  // height가 지정되지 않으면 dragscroll동작 오류
  onResize(): void {
    this.windowSize = { x: window.innerWidth, y: window.innerHeight };
  }

  // 이미지 선택 시 답안지 오픈
  // imageClick() {
  //   if(this.isDrag == false) {
  //     if(this.getWindowSize() < 800) {
  //       this.drawNav = !this.drawNav;
  //     }
  //   } else {
  //     this.isDrag = false;
  //   }
  // }

  // 기출문제 시험 이미지 삭제
  async deleteTestPaper(item: TestPaperOVO) {
    if(this.isDelete) {
      const res =  await this.$confirm('삭제 하시겠어요?', CommonUtils.baseConfirmOption);

      if(res) {
        axios.delete(`omr/test-paper/${item.tpNo}`)
        .then(r => {
          axios.get(`omr/test-papers`, {params: {emNo: this.emNo}})
          .then(r => {
            this.testPapers = r.data
            this.$emit('update:testPaperCount', this.testPapers.length)
          })
        })
      }
    }
  }

  getWindowSize(){
    switch (this.$vuetify.breakpoint.name) {
      case 'xs': return 220
      case 'sm': return 400
      case 'md': return 500
      case 'lg': return 600
      case 'xl': return 800
    }
  }

  created() {
    // 기출문제 시스템 업로드 이미지 조회
    // 저작권때문에 막아야함..
    if(Constants.IS_USED_TEST_PAPER_LIBRARY) {
      axios.get(`omr/test-papers/library`, {params: {emNo: this.emNo}})
      .then(r => {
        this.testPaperLibraries = r.data
      })
    }

    // 개인이 업로드한 기출문제 시험지 조회
    axios.get(`omr/test-papers`, {params: {emNo: this.emNo}})
    .then(r => {
      this.testPapers = r.data;
      // 로딩 완료
      this.isLoadedTestImages = true;
    })

    this.onResize();
  }
}
